import React, { forwardRef } from 'react';

/**
 * Uppercase section label — wraps `.critic-eyebrow`.
 * @param {object} props
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 * @param {React.ElementType} [props.as='p']
 */
const Eyebrow = forwardRef(function Eyebrow(
  { className = '', children, as: Comp = 'p', ...rest },
  ref
) {
  return (
    <Comp ref={ref} className={`critic-eyebrow ${className}`.trim()} {...rest}>
      {children}
    </Comp>
  );
});

export default Eyebrow;
